import { css } from 'styled-components';
import { colors } from '../../../style';
import { actionColor, actionLight } from '../../../style/theme-helpers';

export const clickableTableCellVariants = {
  'border-right': css`
    border-right: 1px solid ${colors.gray300};
    color: ${actionColor};
    background: ${colors.transparent};

    &:hover:not(:disabled):not([disabled]) {
      background-color: ${colors.gray100};
      border-color: ${colors.transparent};
    }

    &:active:not(:disabled):not([disabled]) {
      background-color: ${actionLight};
      border-color: ${actionLight};
      color: ${actionColor};
    }

    &:disabled,
    &[disabled] {
      background-color: ${colors.transparent};
      border-color: ${colors.transparent};
      color: ${colors.gray600};
      cursor: not-allowed;
    }
  `,
  'secondary-action': css`
    color: ${actionColor};
    background: ${colors.transparent};
    border-color: ${colors.transparent};

    &:hover:not(:disabled):not([disabled]) {
      background-color: ${colors.gray100};
      border-color: ${colors.transparent};
    }

    &:active:not(:disabled):not([disabled]) {
      background-color: ${actionLight};
      border-color: ${actionLight};
      color: ${actionColor};
    }

    &:disabled,
    &[disabled] {
      background-color: ${colors.transparent};
      border-color: ${colors.transparent};
      color: ${colors.gray600};
      cursor: not-allowed;
    }
  `,
  gray100: css`
    background-color: ${colors.gray100};
  `,
  'violet-lightest': css`
    background-color: #e5e7fb;
    color: ${colors.gray900};
    text-align: center;
    font-weight: 600;
    border-color: ${colors.transparent};
  `,
  'violet-light': css`
    background-color: #c7ccff;
    color: ${colors.gray900};
    border-color: ${colors.transparent};
  `,
  'violet-medium': css`
    background-color: #a5acff;
    color: ${colors.white};
    border-color: ${colors.transparent};
  `,
  'violet-dark': css`
    background-color: #818cf8;
    color: ${colors.white};
    border-color: ${colors.transparent};
  `,
  'violet-darkest': css`
    background-color: #6366f1;
    color: ${colors.white};
    border-color: ${colors.transparent};
  `,
};
